// extracted by mini-css-extract-plugin
export default {"hidden":"DescriptionTab__hidden-udL9W"};